import { NEXT_INSTANCE } from '@/lib/api'
import { getMeta } from '@/utils/getMeta'
import { setCookie } from 'cookies-next'
import { create } from 'zustand'

const useMeta = create((set, get) => ({
  locale: 'th',
  metaSettings: null,
  bFanBadges: [],
  metaInfo: null,
  centerGroups: null,
  centers: null,
  taxonomies: null,
  campusHospitals: null,
  metaIsLoading: true,
  isGroupPage: true,
  seoRedirect: null,
  hospitalsByZone: null,
  isExactLocale: (locale = '') => {
    return get().locale === locale
  },
  fetchMeta: async (locale = 'th', hospital = 'group') => {
    /**
     * fetch meta has fallback to group used in initialDataProvider
     */
    // if locale contains sw.js, return
    if (locale.includes('.') || hospital.includes('.')) {
      return null
    }
    set({ locale })
    return getMeta(locale, hospital)
  },
  setPopupCookie: (popupCookieName) => {
    // Cookies 10 days
    let days = 10
    setCookie(popupCookieName, true, {
      expires: new Date(Date.now() + days * 24 * 3600000),
    })
  },
  uploadFile: async (file, token) => {
    try {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('token', token)

      const res = await NEXT_INSTANCE.post('/next-api/upload', formData)
      return res.data
    } catch (err) {
      console.error(err?.response?.data)
      return err?.response?.data
    }
  },
  getCenter: (value, key = '_slug') => {
    // Cause a bug when has center with no slug [Have to filter out]
    return get().centers?.find(
      (center) => center[key] === value && center?._slug
    )
  },
  getTaxonomy: (value = '', key = '_id', category = '') => {
    return get().taxonomies?.[category]?.terms.find((x) => x[key] === value)
  },
  getBadge: (badgeId) => {
    return get().bFanBadges?.find((x) => x._id == badgeId)
  },
}))

export default useMeta
